import React, { useContext } from "react";
import { ActionIcon, Box } from "rizzui";
import { MoonIcon, SunIcon } from "@heroicons/react/24/outline";
import { ThemeContext } from "../context/themeContext";
import "../index.css";

export function ThemeSwitcher() {
  const { theme, setTheme } = useContext(ThemeContext);

  const toggleTheme = () => {
    const newTheme = theme === "dark" ? "light" : "dark";
    setTheme(newTheme);
    localStorage.setItem("RingconnectTheme", newTheme);
    document.documentElement.setAttribute("data-theme", newTheme);
  };
  return (
    <>
      <Box onClick={toggleTheme}>
        <ActionIcon variant="text">
          <SunIcon className="h-5 w-5 dark:hidden" />
          <MoonIcon className="absolute h-5 w-5 hidden dark:block" />
        </ActionIcon>
      </Box>
    </>
  );
}
